import { SYSTEM_META_CONFIG, NODE_ENV } from './config/globals'

if (SYSTEM_META_CONFIG && SYSTEM_META_CONFIG['version']) {
  console.log(
    [
      `%c🎐`,
      `${SYSTEM_META_CONFIG['name']}[version:${SYSTEM_META_CONFIG['version']}-${SYSTEM_META_CONFIG['hash']}]`,
      `BUILD: ${SYSTEM_META_CONFIG['currentTime']}[${NODE_ENV}]`,
    ].join(' '),
    'color:#666'
  )
}

export const loadGlobalConfig = () => {
  return SYSTEM_META_CONFIG
}
